import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  gap: 8px;
`;

export const TitleContainer = styled.div`
  display: flex;
  padding: 24px 20px;
  align-items: center;
  gap: 8px;
`;

export const SettingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
